import { CalibrationTypeEnum, ProcessTypeEnum } from "src/app/shared/interfaces/process.interface";
import { GlobalizationConfig } from "src/app/shared/interfaces/globalization-config.interface";
import { QuestionConfig, QuestionGroup, QuestionTypeConfig } from "src/app/shared/interfaces/process-config.interface";
import { Goal } from "../../goals/_interfaces/goal.interface";
import { GoalTypeEnum } from "../../shared/enums/GoalTypeEnum";
import { AttributeItem } from "../../shared/interfaces/attribute-item";

export class Version {
    public id?: number;
    public type: ProcessTypeEnum;
    public versionName: string;
    public name: string;
    public versionDate: Date;
    public globalizationConfig: GlobalizationConfig;
    public questions: Array<QuestionConfig>;
    public relatedQuestions: Array<QuestionConfig>;
    public questionGroups: Array<QuestionGroup>;
    public managerQuestionGroups?: Array<QuestionGroup>;
    public questionTypeConfigs?: Array<QuestionTypeConfig>;
    //360 evaluation
    public optionalManagerEvaluation?: boolean;
    public skipSelectionStep?: boolean;
    public disableRelationColumn?: boolean;
    public enableValuationLimit?: boolean;
    public threeSixtyEvaluationLimit?: number;
    public threeSixtyEvaluationTimespanInHours?: number;

    //calibration
    public calibrationType?: CalibrationTypeEnum;
    public hideAnswerToManager?: boolean;
    public hideAnswerToUser?: boolean;
    public onlyFinalFeedbackValidation?: boolean;
    public onlyFinalFeedbackSeeReviews?: boolean;
    
    public anonymousReport?: boolean;
    public hrOnlyReport?: boolean;
    public seePreviousEvaluations?: boolean;
    public blockLineManagerEvaluation?: boolean;
    public blockThreeSixtyEvaluators?: boolean;
    public consentGoalsGlobalizationConfig: GlobalizationConfig;
    public goalType: GoalTypeEnum;
    public consentAttributes: Array<AttributeItem>;
    public consentGoals: Array<Goal>;
    public validationProcessId: number;
    public selectionProcessId: number;
    public manualReopeningTime?: number = null;
    public skipTwoPlusTwoCoachingEvaluation: boolean = false;
    public userAttributesAllowed: number[];
    public userAttributesItemAllowed: Array<AttributeItem>;
    public headAttribute?: number = null;

    constructor(type: ProcessTypeEnum) {
        this.type = type;
        this.versionDate = new Date();
        this.globalizationConfig = new GlobalizationConfig();
        this.questions = [];
        this.questionGroups = [];
        this.managerQuestionGroups = [];
        this.questionTypeConfigs = [];
    }
}
